import { prop, propObject, required } from "@rxweb/reactive-form-validators";
import { Resource } from "src/app/core/jsonapi/resource";
import { Case } from "../../cases/_types/case";

export class MailMessageAttachment extends Resource {
    public override type = 'mailMessageAttachments';

    @prop()
    public mailMessageId!: string;

    @prop()
    public fileId!: string;

    @propObject(File)
    public file?: File;

}